(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.desktopDrawer = document.querySelector('.desktop-drawer');
      this.desktopDrawerOverlay = document.querySelector('.desktop-drawer-overlay');
      this.body = document.querySelector('body');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isIndexPage = window.location.pathname === '/';

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if (this.isIndexPage) {
        this.initLogoSize();
      }
      
      // this.updateHeroHeight();
      this.createObserver();
      this.initDesktopDrawer();
      this.initMobileClose();
      this.initSearchModal();
      this.initLocalizationDrawer();
      this.initAnnouncementBar();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);

      if (this.isIndexPage) {
        const hero = document.querySelector('.hero');
        if (hero) {
          let heroObserver = new IntersectionObserver((entries) => {
            const heroEntry = entries[0];
            this.isHeroPassed = !heroEntry.isIntersecting && heroEntry.boundingClientRect.top < 0;
          }, {
            threshold: 0
          });
          
          heroObserver.observe(hero);
        }
      } else {
        this.isHeroPassed = true;
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide || (this.isIndexPage && !this.isHeroPassed)) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    initLogoSize() {
      window.addEventListener('scroll', () => {
        const logo = document.querySelector('#logo');
        const logoTop = logo.getBoundingClientRect().top;
        const headerWrapper = document.querySelector('.shopify-section-group-header-group.section-header');

        if (window.scrollY > 0) {
          logo.classList.remove('scrolled');
          headerWrapper.classList.add('scrolled');
        } else {
          logo.classList.add('scrolled');
          headerWrapper.classList.remove('scrolled');
        }
      });
    }

    toggleDesktopDrawer() {
      if (  this.desktopDrawer.classList.contains('open') ) {
        this.desktopDrawer.classList.remove('open');
        this.desktopDrawerOverlay.classList.remove('show');
        this.body.classList.remove('overflow-hidden');
      } else {
        this.desktopDrawer.classList.add('open');
        this.desktopDrawerOverlay.classList.add('show');
        this.body.classList.add('overflow-hidden');
      }
    }

    hideDesktopDrawerSubMenu() {
      document.querySelectorAll('.desktop-drawer__sublink').forEach(sublink => {
        sublink.classList.remove('show');
      });
    }

    initDesktopDrawer() {
      const staticMenu = document.querySelectorAll('.header__inline-menu--static [data-has-submenu]');
      const desktopDrawer = document.querySelector('.desktop-drawer');
      const drawerMenus = document.querySelectorAll('.desktop-drawer__main-nav [data-link-handle]');

      this.desktopDrawer.addEventListener('click', (event) => {
        if (event.target === this.desktopDrawer) {
          this.toggleDesktopDrawer();
        }
      });

      staticMenu.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const targetMenu = document.querySelector(`#sublink-for-${link.dataset.linkHandle}`);
          const prevActive = document.querySelector('.desktop-drawer__main-nav [data-link-handle].active');
          if (prevActive) {
            prevActive.classList.remove('active');
          }
          document.querySelector(`.desktop-drawer__main-nav [data-link-handle="${link.dataset.linkHandle}"]`).classList.add('active');
          this.hideDesktopDrawerSubMenu();
          targetMenu.classList.add('show');
          this.toggleDesktopDrawer();
        });
      });

      drawerMenus.forEach(menu => {
        menu.addEventListener('click', (event) => {
          event.preventDefault();
          this.hideDesktopDrawerSubMenu();
          const prevActive = document.querySelector('.desktop-drawer__main-nav [data-link-handle].active');
          if (prevActive) {
            prevActive.classList.remove('active');
          }
          document.querySelector(`#sublink-for-${menu.dataset.linkHandle}`).classList.add('show');
          menu.classList.add('active');
        });
      });

      
    }

    initMobileClose() {
      const closeButton = document.querySelector('.menu-drawer__close');
      const orginanalButton = document.querySelector('.header__button-trigger');
      closeButton.addEventListener('click', () => {
        orginanalButton.click();
      });
    }

    initSearchModal() {
      const searchButton = document.querySelectorAll('.header__icon--search');
      const closeButton = document.querySelectorAll('.header__search .search-modal__close-button');
      const modalOverlay = document.querySelectorAll('.header__search .modal-overlay');
      searchButton.forEach(button => {
        button.addEventListener('click', (event) => {
          document.querySelectorAll('.fast-ac-container').forEach(container => {
            container.style.display = 'block';
          });
          event.preventDefault();
          const isLookBookDrawer = event.target.closest('.lookbook-section');
          let searchContainer = event.target.closest('.header__search');
          if (isLookBookDrawer) {
            this.hideOtherDrawers('search');
            searchContainer = document.querySelector('.header-main-nav .header__icons .header__search');
          }

          searchContainer.classList.add('active');
          document.body.classList.add('overflow-hidden', 'search-open');
          searchContainer.querySelector('.search__input').focus();
        });
      });
      
      closeButton.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          document.querySelectorAll('.fast-ac-container').forEach(container => {
            container.style.display = 'none';
          });
          const searchContainer = event.target.closest('.header__search');
          searchContainer.classList.remove('active');
          searchContainer.querySelector('.search__input').blur();
          searchContainer.querySelector('.search__input').value = '';
          document.body.classList.remove('overflow-hidden', 'search-open');
        });
      });

      modalOverlay.forEach(overlay => {
        overlay.addEventListener('click', (event) => {
          document.querySelectorAll('.fast-ac-container').forEach(container => {
            container.style.display = 'none';
          });
          event.preventDefault();
          const searchContainer = event.target.closest('.header__search');
          searchContainer.classList.remove('active');
          searchContainer.querySelector('.search__input').blur();
          searchContainer.querySelector('.search__input').value = '';
          document.body.classList.remove('overflow-hidden', 'search-open');
        });
      });
    }

    hideOtherDrawers(currentDrawer) {
      const lookbookDrawer = document.querySelectorAll('.shop-the-look-drawer');
      const searchContainer = document.querySelector('.header-main-nav .header__icons .header__search');
      const localizationDrawer = document.querySelector('.header-main-nav .header__icons .localization-drawer');
      console.log(currentDrawer);
      if (currentDrawer === 'search') {
        localizationDrawer.classList.remove('active');
        console.log(localizationDrawer);
      }

      if (currentDrawer === 'localization') {
        searchContainer.classList.remove('active');
        document.body.classList.remove('search-open');
        console.log(searchContainer);
      }

      lookbookDrawer.forEach(drawer => {
        drawer.classList.remove('active');
      });
    }

    initLocalizationDrawer() {
      const currencySelector = document.querySelectorAll('.currency-selector__active');
      const localizationDrawer = document.querySelector('.localization-drawer');
      const localizationDrawerClose = document.querySelector('.localization-drawer__close');
      const localizationDrawerOverlay = document.querySelector('.localization-drawer__overlay');
      currencySelector.forEach(selector => {
        selector.addEventListener('click', (event) => {
          event.preventDefault();
          localizationDrawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
          document.querySelector('.header-wrapper').classList.add('overflow-hidden');
          this.hideOtherDrawers('localization');
        });
      });

      localizationDrawerClose.addEventListener('click', (event) => {
        event.preventDefault();
        localizationDrawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      });

      localizationDrawerOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        localizationDrawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      });
    }

    initAnnouncementBar() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
          window.addEventListener('scroll', () => {
              if (window.scrollY > announcementBar.clientHeight) {
                  announcementBar.classList.add('to-hide');
              } else {
                  announcementBar.classList.remove('to-hide');
              }
          });

          const announcementBarHeight = announcementBar.clientHeight;
          // document.querySelector('#MainContent').style.paddingTop = `${announcementBarHeight}px`;
      }
    }

    updateHeroHeight() {
      const shippingBar = document.querySelector('.announcement-bar__inner')?.clientHeight;
      if (!shippingBar) return;
      document.documentElement.style.setProperty('--shippingBarHeight', `${shippingBar}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faqs__item');

    faqItems.forEach((item) => {
      const question = item.querySelector('.faqs__item-question');
      const answer = item.querySelector('.faqs__item-answer');
      const icon = item.querySelector('.faqs__icon');

      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all other items
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.faqs__item-answer').style.maxHeight = null;
            otherItem.querySelector('.faqs__icon').classList.remove('active');
          }
        });

        // Toggle current item
        if (isActive) {
          item.classList.remove('active');
          answer.style.maxHeight = null;
          icon.classList.remove('active');
        } else {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          icon.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
